import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cuándo recibo el material?',
    a: 'Al instante, apenas confirmás el pago te llega por email'
  }, {
    q: '¿Necesito algo especial para abrirlo?',
    a: 'Solo un lector de PDF (gratuito) y una impresora'
  }, {
    q: '¿Puedo imprimirlo en una copistería?',
    a: 'Sí, perfectamente. El instructivo te explica cómo'
  }, {
    q: '¿Qué pasa si tengo problemas con la descarga?',
    a: 'Te asistimos personalmente hasta resolverlo'
  }, {
    q: '¿Las figuritas son de buena calidad?',
    a: 'Sí, son archivos de alta resolución listos para imprimir'
  }, {
    q: '¿Puedo imprimir más de una vez?',
    a: 'Sí, el archivo es tuyo para siempre'
  }, {
    q: '¿Están todos los países del Mundial?',
    a: 'Sí, todos los equipos clasificados están incluidos'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-white" data-id="element-86">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-88">
          <h2 className="text-4xl md:text-5xl text-wc-dark mb-4" data-id="element-89">
            ❓ PREGUNTAS FRECUENTES
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-90">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05
        }} className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-91">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-5 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-92">
                <span className="font-bold text-gray-900 pr-4" data-id="element-93">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-94" />
              </button>
              <AnimatePresence data-id="element-95">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-96">
                    <div className="p-5 bg-white border-t border-gray-100 text-gray-700" data-id="element-97">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}